<template>
  <div class="container">
    <div class="row justify-content-md-center">
        <div class="col-sm-8">
            <div class="card form-domain-card__card border-0" id="form-domain-card">
                <div class="card-body form-domain-card__body">
                    <div
                      v-cloak
                      v-show="domainIsInvalid"
                      v-html="errorMessage"
                      id="error"
                      name="error"
                      class="alert alert-danger"
                      role="alert"
                    ></div>

                    <div class="card-text form-domain-card__text">
                        <form @submit.prevent="submit">
                            <h4 class="form-domain-card__header">Email Address:</h4>
                            <div class="input-group">
                                <input
                                    id="form-domain-email"
                                    v-model="email"
                                    name="email"
                                    type="email"
                                    class="form-control"
                                    placeholder="Enter your email..."
                                    required
                                />
                                <button type="submit" id="form-domain-next-btn" class="btn input-group-addon">
                                  <span class="next-btn" v-cloak>
                                    {{ form.next_button_text }}
                                  </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

  export default {
    name: 'FormDomainValidation',

    props: {
      form: { type: Object },
      settings: { type: Object }
    },

    computed: {
      errorMessage() {
          return this.customErrorMessage
      }
    },

    data: function () {
      return {
          domainIsInvalid: false,
          domainErrorMessage: this.settings.domain_error_message,
          customErrorMessage: '',
          email: ''
      }
    },

    methods: {
      setErrorMessage(customError) {
        this.customErrorMessage = customError ? customError : this.domainErrorMessage
      },

      validateResponse(res) {
        var self = this
        if (res.is_valid) {
            window.location.reload()
        } else {
            self.setErrorMessage(res.email_exists_error)
            self.domainIsInvalid = true
        }
      },

      submit() {
        var self = this

        Http.post('/register/validate', {
            email: this.email,
            formId: this.form.id
        }, function(res) {
            self.validateResponse(res)
        }, function(err) {
            console.log(err)
        })
      }
    },
  }

</script>

<style>
  #form-domain-validation {
    padding: 3em 2em 2em;
  }
</style>